import { format } from "date-fns";
import * as React from "react";

import { DesignToken, Text } from "@livechat/design-system-react-components";

import { DateFormat } from "constants/date";
import { withVar } from "themes/helpers";
import { plural } from "utils/string";

interface IProps {
  nonViewersCount?: number;
  expirationDate?: Date;
}

export const PhaseExpired: React.FC<IProps> = ({ nonViewersCount, expirationDate }) => {
  const formattedExpirationDate = expirationDate && format(expirationDate, DateFormat.MonthDayFullYear);
  return (
    <>
      <Text customColor={withVar(DesignToken.ActionNegativeDefault)}>
        Your subscription expired
        {expirationDate && (
          <>
            {" "}
            on <strong>{formattedExpirationDate}</strong>
          </>
        )}
        .{" "}
        {nonViewersCount && (
          <>
            You had{" "}
            <strong>
              {nonViewersCount} {plural(nonViewersCount, "agent", "agents")}
            </strong>
            .
          </>
        )}
      </Text>
      <Text customColor={withVar(DesignToken.ActionNegativeDefault)}>
        Your account will be fully restored after a successful payment.
      </Text>
    </>
  );
};
